module.exports = __webpack_public_path__ + "img/8.23b907cf.jpg";